/* app/js/src/components/common/wizard/wizard-nav.component.scss */
.cursor-pointer {
  cursor: pointer;
}
nav .btn-next {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .btn-next:focus {
  outline-color: #ffffff;
}
nav .btn-next:hover {
  background-color: white;
  color: #232f3a;
}
nav .disabled.btn-next {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
nav {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
nav .hidden {
  visibility: hidden;
}
nav .btn-back {
  display: flex;
  align-items: center;
  cursor: pointer;
}
nav .rounded-btn,
nav .rounded-btn-prev {
  display: inline-block;
  background: #f1f3f4 no-repeat center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
}
nav .rounded-btn-prev {
  background-image: url(/assets/icons/prev.svg);
  margin-right: 10px;
}
nav .rounded-btn-next {
  background-image: url(/assets/icons/next.svg);
  margin-left: 10px;
  margin-right: 0px;
}
nav .apply-title,
nav .btn-next::before,
nav .btn-next::after {
  position: absolute;
  left: 120%;
  color: #c18efa;
  width: auto;
  white-space: nowrap;
  height: 100%;
  top: 0;
  line-height: 230%;
  font-size: 1em;
  pointer-events: none;
  opacity: 0;
  -ms-transform: translateY(5px);
  -webkit-transform: translateY(5px);
  transform: translateY(5px);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
nav .btn-next {
  padding-left: 17px;
  padding-right: 17px;
  position: relative;
}
nav .btn-next::after {
  content: attr(data-success);
}
nav .btn-next::before {
  content: attr(data-failure);
}
nav .btn-next.succeeded::after {
  opacity: 1;
  -ms-transform: translateY(0);
  -webkit-transform: translateY(0);
  transform: translateY(0);
}
nav .btn-next.failed::before {
  opacity: 1;
  -ms-transform: translateY(0);
  -webkit-transform: translateY(0);
  transform: translateY(0);
}
.buttons-container {
  display: flex;
  flex-basis: 100%;
  justify-content: space-between;
}
.next-prev-container {
  display: flex;
  justify-content: space-between;
  flex-basis: 150px;
}
/*# sourceMappingURL=wizard-nav.component.css.map */
